export default __webpack_public_path__ + "assets/images/518-small.png";